/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as EmailsRouteImport } from './routes/emails'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersCustomerIdRouteImport } from './routes/users.$customerId'
import { Route as OrdersInvoiceIdRouteImport } from './routes/orders.$invoiceId'

const EmailsRoute = EmailsRouteImport.update({
  id: '/emails',
  path: '/emails',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersCustomerIdRoute = UsersCustomerIdRouteImport.update({
  id: '/users/$customerId',
  path: '/users/$customerId',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersInvoiceIdRoute = OrdersInvoiceIdRouteImport.update({
  id: '/orders/$invoiceId',
  path: '/orders/$invoiceId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/emails': typeof EmailsRoute
  '/orders/$invoiceId': typeof OrdersInvoiceIdRoute
  '/users/$customerId': typeof UsersCustomerIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/emails': typeof EmailsRoute
  '/orders/$invoiceId': typeof OrdersInvoiceIdRoute
  '/users/$customerId': typeof UsersCustomerIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/emails': typeof EmailsRoute
  '/orders/$invoiceId': typeof OrdersInvoiceIdRoute
  '/users/$customerId': typeof UsersCustomerIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/emails' | '/orders/$invoiceId' | '/users/$customerId'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/emails' | '/orders/$invoiceId' | '/users/$customerId'
  id: '__root__' | '/' | '/emails' | '/orders/$invoiceId' | '/users/$customerId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  EmailsRoute: typeof EmailsRoute
  OrdersInvoiceIdRoute: typeof OrdersInvoiceIdRoute
  UsersCustomerIdRoute: typeof UsersCustomerIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/emails': {
      id: '/emails'
      path: '/emails'
      fullPath: '/emails'
      preLoaderRoute: typeof EmailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$customerId': {
      id: '/users/$customerId'
      path: '/users/$customerId'
      fullPath: '/users/$customerId'
      preLoaderRoute: typeof UsersCustomerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$invoiceId': {
      id: '/orders/$invoiceId'
      path: '/orders/$invoiceId'
      fullPath: '/orders/$invoiceId'
      preLoaderRoute: typeof OrdersInvoiceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  EmailsRoute: EmailsRoute,
  OrdersInvoiceIdRoute: OrdersInvoiceIdRoute,
  UsersCustomerIdRoute: UsersCustomerIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
